module.exports = __webpack_public_path__ + "static/img/ott.05e7887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ott.jpg
// module id = GhZU
// module chunks = 0